import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Input } from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import numeral from 'numeral';

const PriceInput = ({
                        price,
                        priceClean,
                        precioMin,
                        precioMax,
                        disablePrice,
                        priceExists,
                        loadingFee,
                        messagePrice,
                        onChangePrice,
                        onChangePriceRange
                    }) => {
    // Format the min/max prices for display in the error message
    const formatPrice = (value) => {
        return numeral(value).format('0,0[,]0').replace(/,/g, ".");
    };

    return (
        <>
            <Row>
                <Col md={6}>
                    <div className="form-group">
                        <label className="labe-black-simulation-home" htmlFor="price">Precio Vehículo</label>
                        <CurrencyFormat
                            name="price"
                            className="form-control"
                            onChange={onChangePrice}
                            value={price}
                            decimalSeparator=","
                            thousandSeparator="."
                            prefix={"$"}
                            onBlur={(e) => {
                                let value = e.target.value.replace(/[.$]/g, "");
                                value = parseInt(value || 0);
                                if (value > precioMax) {
                                    onChangePriceRange(precioMax);
                                } else if (value < precioMin) {
                                    onChangePriceRange(precioMin);
                                }
                            }}
                            disabled={(!disablePrice && priceExists) || loadingFee}
                            id="price"
                            placeholder="Ingrese el precio"
                            required
                            maxLength={16}
                            aria-label="Precio del vehículo"
                            aria-describedby={messagePrice ? "price-error" : undefined}
                        />
                        {messagePrice && (
                            <div id="price-error" className="text-danger small mt-1">
                                El valor del vehículo no puede ser menor a ${formatPrice(precioMin)} y mayor a ${formatPrice(precioMax)}
                            </div>
                        )}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={11} sm={11} className="mt-3 mb-3 sf-range-container">
                    <Input
                        id="price-range"
                        className="sf-range"
                        name="range"
                        type="range"
                        max={precioMax}
                        min={precioMin}
                        disabled={(!disablePrice && priceExists) || loadingFee}
                        value={parseInt(priceClean) || 0}
                        onChange={(e) => onChangePriceRange(parseInt(e.target.value))}
                        aria-label="Rango de precio del vehículo"
                    />
                </Col>
            </Row>
        </>
    );
};

// PropTypes
PriceInput.propTypes = {
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    priceClean: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    precioMin: PropTypes.number.isRequired,
    precioMax: PropTypes.number.isRequired,
    disablePrice: PropTypes.bool,
    priceExists: PropTypes.bool,
    loadingFee: PropTypes.bool,
    messagePrice: PropTypes.string,
    onChangePrice: PropTypes.func.isRequired,
    onChangePriceRange: PropTypes.func.isRequired
};

// Default props
PriceInput.defaultProps = {
    price: '',
    priceClean: 0,
    disablePrice: false,
    priceExists: false,
    loadingFee: false,
    messagePrice: ''
};

export default PriceInput;